const zIndexses = {
  modalContainer: 999,
  modal: 99,
  responsiveModal: 99,
  mainMenuMultiColorLogoTrapBlock: 99,
  mainMenuBar: 99,
  mainMenuOverlay: 98,
  datesFilterBoxIcon: 15,
  datesFilterBox: 10,
  summary: 10,
  driverMapError: 10,
  quotePrice: 4,
  appBar: 5,
  feedBack: 5,
  customSelect: 5,
  stopAddressFloatingCityQuote: 4,
  fieldError: 4,
  shareMenu: 1,
  actionsMenu: 1,
  dayPickerInputOverlay: 1,
  stopLabel: 'initial',
  stopInput: 'initial',
};

export default zIndexses;
